document.addEventListener("DOMContentLoaded", () => {
  let nowTimer = null;
  let lateTimer = null;

  function hasAddonRuntime() {
    return Boolean(
      document.querySelector(".apo-total-addcharge") ||
      document.querySelector(".avpoptions-container__v2") ||
      document.querySelector("tire-widget") ||
      document.querySelector("[data-more-addons-total]") ||
      document.querySelector("[data-uca-addons-root]")
    );
  }

  function runSync() {
    if (!hasAddonRuntime()) return;

    const sync = window.MudifyAddonPriceSync;
    if (!sync || typeof sync.applyCombinedPrice !== "function") return;
    sync.applyCombinedPrice();
  }

  function scheduleNow() {
    clearTimeout(nowTimer);
    nowTimer = setTimeout(runSync, 0);
  }

  function scheduleLate(delay = 500) {
    clearTimeout(lateTimer);
    lateTimer = setTimeout(runSync, delay);
  }

  function syncNowAndLate(delay = 500) {
    scheduleNow();
    scheduleLate(delay);
  }

  syncNowAndLate();

  const target = document.querySelector(".avpoptions-container__v2");
  if (target) {
    const obs = new MutationObserver(() => {
      syncNowAndLate();
    });
    obs.observe(target, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  document.body.addEventListener("change", (event) => {
    const target = event.target;
    if (!target || !target.matches) return;

    const isAvisSwatch = target.matches(
      ".avp-productoptiontextcolor, .avp-productoptionbackground"
    );
    const isAvisRadio =
      target.matches('input[type="radio"]') &&
      target.closest(".avpoptions-container__v2");

    if (isAvisSwatch || isAvisRadio) {
      syncNowAndLate();
    }
  });

  document.addEventListener("custom:moreaddons:change", () => {
    syncNowAndLate();
  });

  document.addEventListener("tire-widget:change", () => {
    syncNowAndLate();
  });

  document.addEventListener("uca:addon-change", () => {
    syncNowAndLate();
  });

  document.addEventListener("variant:change", () => {
    syncNowAndLate(420);
  });
});
